import {useContext} from "react";
import AppContext from "../AppContext";
import {Redirect} from "react-router-dom";

export default function Logout() {
    const app = useContext(AppContext);
    app.logout();
    return <Redirect to="/" />;
}